export default "__VITE_ASSET__BvqOpvU2__"